import { Component } from '@angular/core';
import { ConnectionOverlayService } from './connection-overlay.service';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { animate, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';

@Component({
  selector: 'upskill-connection-overlay',
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './connection-overlay.component.html',
  styleUrl: './connection-overlay.component.scss',
  animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate(300, style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate(300, style({ opacity: 0 }))
            ])
        ])
    ]
})
export class ConnectionOverlayComponent {
  protected faTriangleExclamation = faTriangleExclamation;

  constructor(private connectionOverlayService: ConnectionOverlayService, private router: Router) {
  }

  get shouldShow(): boolean {
    return this.connectionOverlayService.isShown;
  }

  get showContinue(): boolean {
    return this.connectionOverlayService.showContinue;
  }

  get showExit(): boolean {
    return this.connectionOverlayService.showExit;
  }

  doHide() {
    this.connectionOverlayService.hide();
  }

  doExit() {
    this.connectionOverlayService.hide();
    this.router.navigate(['/']);
  }
}
